import React, {useEffect} from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import Modal from 'Shared/components/Modal';
// @ts-ignore
import QRCode from 'Shared/utilities/QRCode';
import './ShareLink.sass';

type ShareLinkProps = {
  onClose: () => void;
} & RouteComponentProps;

const ShareLink = (props: ShareLinkProps) => {
  useEffect(() => {
    // @ts-ignore
    const qrCode = new QRCode(document.getElementById('qrcode'), {
      text: process.env.REACT_APP_BASE_SITE_URL + props.location.pathname,
    });
  });

  return (
    <Modal open onClose={props.onClose} title="Share Link">
      <div className="share-link__qr-code">
        <p>Share the below code to link your current screen:</p>
        <div id="qrcode" />
      </div>
    </Modal>
  );
};

export default withRouter(ShareLink);
